if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.viewer.addEventListener("click", this._onClickFunc.bind(this));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }
    _onClickFunc(event) {
      if(event.offsetX > this.offsetWidth / 2) {
        let val = false;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch, index) => {
           if(mediaToSwitch.querySelector('button').getAttribute('aria-current') && val == false && index < this.elements.thumbnails.querySelectorAll('[data-target]').length - 1 ) {
            let nextEle = this.elements.thumbnails.querySelectorAll('[data-target]')[index+1];
            this.setActiveMedia(nextEle.dataset.target, false);
            val = true;
           }
        });
      }else {
        let val = false;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch, index) => {
           if(mediaToSwitch.querySelector('button').getAttribute('aria-current') && val == false && index > 0 ) {
            let nextEle = this.elements.thumbnails.querySelectorAll('[data-target]')[index-1];
            this.setActiveMedia(nextEle.dataset.target, false);
            val = true;
           }
      });
    }
    }
    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* HARDDROP homepage Psycho Panda: make visible side arrows switch the desktop media gallery. */
(function(){
  function bindPandaArrows(){
    var section = document.querySelector('[id$="__featured_panda"]');
    if(!section) return;
    var gallery = section.querySelector('media-gallery');
    var viewer = section.querySelector('.featured-product__slider');
    if(!gallery || !viewer || typeof gallery.setActiveMedia !== 'function' || viewer.dataset.hdArrowBound === '1') return;
    var prev = viewer.querySelector('.slider-button--prev');
    var next = viewer.querySelector('.slider-button--next');
    var thumbs = gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]');
    if(!prev || !next || thumbs.length < 2) return;
    viewer.dataset.hdArrowBound = '1';

    function currentIndex(){
      var found = 0;
      thumbs.forEach(function(item,index){
        var button = item.querySelector('button');
        if(button && button.hasAttribute('aria-current')) found = index;
      });
      return found;
    }
    function switchBy(delta, event){
      event.preventDefault();
      event.stopImmediatePropagation();
      var index = currentIndex() + delta;
      if(index < 0) index = thumbs.length - 1;
      if(index >= thumbs.length) index = 0;
      gallery.setActiveMedia(thumbs[index].dataset.target, false);
    }
    prev.addEventListener('click', function(e){switchBy(-1,e);}, true);
    next.addEventListener('click', function(e){switchBy(1,e);}, true);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindPandaArrows);
  else bindPandaArrows();
  document.addEventListener('shopify:section:load', bindPandaArrows);
})();
